import { useController } from 'react-hook-form';

import { useIntl } from '@zenbusiness/application-commons-intl';

import { buildFieldName } from '#client/utils/form';

import { FIELD_NAMES } from '../../constants';

const MAX_LENGTH = 50;

export default function useCityField({ namePrefix, validation } = {}) {
  const { formatMessage } = useIntl();

  const defaultValidation = {
    required: formatMessage(
      { id: 'shopping.component.addressFieldset.cityField.error.required' },
      { label: 'City' }
    ),
    maxLength: {
      message: formatMessage(
        { id: 'shopping.component.addressFieldset.cityField.error.maxLength' },
        { label: 'City', maxLength: MAX_LENGTH }
      ),
      value: MAX_LENGTH
    }
  };

  const fieldName = buildFieldName(FIELD_NAMES.CITY, namePrefix);

  const {
    field: { onBlur, ...field },
    fieldState: { error }
  } = useController({
    defaultValue: '',
    name: fieldName,
    rules: { ...defaultValidation, ...validation }
  });

  const handleBlur = (e) => {
    field.onChange(e.target.value.trim());
  };

  return {
    error,
    field: {
      ...field,
      value: field.value ?? '',
      onBlur: handleBlur
    }
  };
}
